import './App.css'
import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './components/home';
import Login from './components/login'
import Register from './components/register';
import Demo from './components/demo';
import Comparison from './components/comparison';
import Feedback from './components/feedback';
import Contact from './components/contact';

const App = () => {
  return (
      <Router>
        <div>
          <Routes >
              <Route path="/" element={<Home/>} />
              <Route path="/login" element={<Login/>} />
              <Route path="/register" element={<Register/>}/>
              <Route path="demo" element={<Demo/>}/>
              <Route path="/comparison" element={<Comparison/>}/>
              <Route path="/feedback" element={<Feedback/>}/>
              <Route path='/contact' element={<Contact/>}/>
          </Routes>
        </div>
      </Router>
  );
};

export default App;
